import React from 'react'
import EcommerceDashboard from '../../../Components/Dashboard/Ecommerce'

export default function Ecommerce() {
    return (
        <div className='page-body'>
            <EcommerceDashboard />
        </div>
    )
}